import AnalyticsBarChart from './AnalyticsBarChart.component';

export default AnalyticsBarChart;
